import { validateFileType } from "@utils"
import { useState } from "react"

export const useUploads = ({ name, setValue, maxFiles = 3 }) => {
  const [files, setFiles] = useState([])

  const allowedFileTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/jpeg",
    "image/png",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ]

  const handleFileChange = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const selectedFiles = Array.from(e.target.files)
    // Filter out invalid types
    const validFiles = selectedFiles.filter((file) => validateFileType(file, allowedFileTypes))
    // Limit to maxFiles
    const newFiles = [...files, ...validFiles].slice(0, maxFiles)
    setFiles(newFiles)
    setValue(name, newFiles)
  }

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index)
    setFiles(newFiles)
    setValue(name, newFiles)
  }

  return {
    files,
    handleFileChange,
    removeFile,
  }
}
